<!-- 区域配置 -->
<template>
     <paper class="operateOrder">
        <m-pane
            ref="tablePage"
            class="operateOrder"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :currentPage="searchParams.pageNo"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @selectChange="selectChange"
        >
            <span slot="search-list-advance-right">
                <el-button class="mgl-10" @click="reset">重 置</el-button>
            </span>
            <div slot="table-module-btn">
                <el-tooltip class="item" effect="dark" content="新增" placement="bottom">
                    <el-button size="mini" icon="el-icon-plus" @click="addData"></el-button>
                </el-tooltip>
                <reportExport #default="{ submit }" reportCode="OPERATE_ORDER_EXPORT">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span class="mgl-10">
                            <el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <el-button type="primary" @click="handleEdit">修改</el-button>
                <el-button type="primary" @click="handleDelete">删 除</el-button>
                <el-button type="primary" @click="handleEnable">启 用</el-button>
                <el-button type="primary" @click="handleDisable">停 用</el-button>
            </div>
        </m-pane>
        <edit-dialog
            v-if="editDialogVisible"
            :dialogVisible.sync="editDialogVisible"
            :title="title"
            :rowData="rowData"
            @handleClose="handleClose">
        </edit-dialog>
    </paper>
</template>

<script>
import { dictWithUrl } from '@/components/lots/api.js';
import mPane from '@/components/otpPanel';
import paper from '@/components/core/paper/Paper';
import reportExport from '@/components/lots/reportExportPlugin';
import dayjs from 'dayjs';
import {
    operateOrderConfigQueryByPage,
    operateOrderConfigDelete,
    operateOrderConfigEnable,
    operateOrderConfigDisable
} from '@otp/api/configCenter/operateOrder';
import config from './config.js';
import EditDialog from './component/EditDialog';

export default {
    name: 'operateOrder',
    components: { mPane, reportExport, EditDialog, paper },
    data () {
        return {
            config,
            totalData: [],
            selectData: [],
            loading: false,
            editDialogVisible: false,
            title: '新增',
            selectLoading: false,
            pageTotal: 0,
            searchParams: {
                createTimeStart: dayjs(new Date()).subtract(30, 'day').format('YYYY-MM-DD 00:00:00'),
                createTimeEnd: dayjs(new Date()).format('YYYY-MM-DD 23:59:59'),
                pageNo: 1,
                pageSize: 10
            },
            rowData: {},
            isFirstSearch: true,
            dict: [
                'ANNTO_FORMWORK_OTP'
            ],
            selectRow: [] // 选中行数据
        };
    },
    methods: {
        // 获取下载模板路径
        // async getDictList () {
        //     return dictWithUrl(this.dict.join(',')).then(res => {
        //         if (res && +res.code === 0) {
        //             this.dictList = res.data;
        //             this.config.ImportContent[0].downLoadInfo.url = this.dictList['ANNTO_FORMWORK_OTP'].;
        //         }
        //     });
        // },
        // 获取数据
        getList () {
            this.isFirstSearch = false;
            this.loading = true;
            operateOrderConfigQueryByPage(this.searchParams).then(res => {
                if (res && +res.code === 0) {
                    this.totalData = this.formatData(res.data.list) || [];
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.loading = false;
            });
        },

        // 接口返回数据处理
        formatData (data) {
            data.forEach(e => {
                e.innerFlag = e.innerFlag + '';
                e.mideaFlag = e.mideaFlag + '';
                e.externalFlag = e.externalFlag + '';
                e.activeFlag = e.activeFlag + '';
                const arr = [];
                if (e.innerFlag === '1') {
                    arr.push('内部业务');
                }
                if (e.mideaFlag === '1') {
                    arr.push('美的渠道');
                }
                if (e.externalFlag === '1') {
                    arr.push('外部业务');
                }
                e.loadList = arr.join(',');
            });
            return data;
        },

        // 重置查询参数
        reset () {
            this.$refs.tablePage.$refs.searchList.dataInit(null, true);
        },

        // 新增
        addData () {
            this.title = '新增';
            this.editDialogVisible = true;
        },

        // 修改
        handleEdit () {
            if (this.selectData.length > 1) {
                return this.$message.warning('请仅选择一条数据');
            }
            this.title = '编辑';
            this.rowData = this.selectData[0];
            this.editDialogVisible = true;
        },

        // 关闭弹窗
        handleClose (flag) {
            if (flag) {
                this.getList();
            }
            this.editDialogVisible = false;
        },

        // 导出
        exportFile (submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            submit({
                ...this.searchParams,
                beginDate2: '2020-11-11 00:00:00', // 后端固定要传参数
                endDate2: '2030-11-11 00:00:00'
            });
            this.isFirstSearch = false;
        },

        // 查询
        searchChange (data) {
            // 处理时间
            if (data.createTime && data.createTime.length) {
                data.createTimeStart = dayjs(data.createTime[0]).format('YYYY-MM-DD HH:mm:ss');
                data.createTimeEnd = dayjs(data.createTime[1]).format('YYYY-MM-DD HH:mm:ss');
            } else {
                return this.$message.warning('查询时间范围不能为空');
            }
            delete data.createTime;
            this.searchParams = {
                ...this.searchParams,
                ...data,
                pageNo: 1
            };
            this.getList();
        },

        // 选中
        selectChange (data) {
            this.selectData = data;
        },

        // 批量停用
        handleDisable () {
            this.executeCommand(operateOrderConfigDisable, '停用');
        },

        // 批量启用
        handleEnable () {
            this.executeCommand(operateOrderConfigEnable, '启用');
        },

        // 批量删除
        handleDelete () {
            if (this.selectData.some(v => +v.activeFlag === 1)) {
                return this.$message.warning(`仅可删除停用的数据`);
            }
            this.executeCommand(operateOrderConfigDelete, '删除');
        },
        /**
         * @description 执行函数
         * @param {*} fn 接口名称
         * @param {*} tip 提示语
         */

        executeCommand (fn, tip) {
            if (!this.selectData.length) { return this.$message.warning('请至少选择一项'); }
            this.$confirm(`确定对所选数据进行${tip}`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        const idList = this.selectData.map(v => v.id);
                        fn(idList).then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success(`${tip}成功`);
                                done();
                            };
                        }).finally(() => {
                            instance.confirmButtonLoading = false;
                        });
                    } else {
                        done();
                    }
                }
            }).then(() => {
                this.getList();
            }).catch(() => { });
        },

        // 分页器页数变化
        pageChange (data) {
            this.searchParams.pageNo = data;
            this.getList();
        },

        // 分页器页数大小变化
        sizeChange (data) {
            this.searchParams.pageNo = 1;
            this.searchParams.pageSize = data;
            this.getList();
        }
    },
    async mounted () {
        // await this.getDictList();
        this.getList();
    }
};
</script>
<style scoped lang="less">
.operateOrder {
    .reset {
        margin-left: 10px;
    }
}
</style>
